// src/app/redux/actions/niveauCriticiteActions.js

export const FETCH_NIVEAU_CRITICITE_REQUEST = "FETCH_NIVEAU_CRITICITE_REQUEST";
export const FETCH_NIVEAU_CRITICITE_SUCCESS = "FETCH_NIVEAU_CRITICITE_SUCCESS";
export const FETCH_NIVEAU_CRITICITE_FAIL    = "FETCH_NIVEAU_CRITICITE_FAIL";

export const CREATE_NIVEAU_CRITICITE_REQUEST = "CREATE_NIVEAU_CRITICITE_REQUEST";
export const CREATE_NIVEAU_CRITICITE_SUCCESS = "CREATE_NIVEAU_CRITICITE_SUCCESS";
export const CREATE_NIVEAU_CRITICITE_FAIL    = "CREATE_NIVEAU_CRITICITE_FAIL";

export const UPDATE_NIVEAU_CRITICITE_REQUEST = "UPDATE_NIVEAU_CRITICITE_REQUEST";
export const UPDATE_NIVEAU_CRITICITE_SUCCESS = "UPDATE_NIVEAU_CRITICITE_SUCCESS";
export const UPDATE_NIVEAU_CRITICITE_FAIL    = "UPDATE_NIVEAU_CRITICITE_FAIL";

export const DELETE_NIVEAU_CRITICITE_REQUEST = "DELETE_NIVEAU_CRITICITE_REQUEST";
export const DELETE_NIVEAU_CRITICITE_SUCCESS = "DELETE_NIVEAU_CRITICITE_SUCCESS";
export const DELETE_NIVEAU_CRITICITE_FAIL    = "DELETE_NIVEAU_CRITICITE_FAIL";

export const SET_NIVEAU_CRITICITE_LOADING   = "SET_NIVEAU_CRITICITE_LOADING";
export const CLEAR_NIVEAU_CRITICITE_ERROR   = "CLEAR_NIVEAU_CRITICITE_ERROR";

// Action creators
export const fetchNiveauCriticiteRequest = () => ({ type: FETCH_NIVEAU_CRITICITE_REQUEST });
export const fetchNiveauCriticiteSuccess = (data) => ({ type: FETCH_NIVEAU_CRITICITE_SUCCESS, payload: data });
export const fetchNiveauCriticiteFail    = (error) => ({ type: FETCH_NIVEAU_CRITICITE_FAIL, error });

export const createNiveauCriticiteRequest = (payload) => ({ type: CREATE_NIVEAU_CRITICITE_REQUEST, payload });
export const createNiveauCriticiteSuccess = (data)    => ({ type: CREATE_NIVEAU_CRITICITE_SUCCESS, payload: data });
export const createNiveauCriticiteFail    = (error)   => ({ type: CREATE_NIVEAU_CRITICITE_FAIL, error });

export const updateNiveauCriticiteRequest = (id, payload) => ({ type: UPDATE_NIVEAU_CRITICITE_REQUEST, payload: { id, payload } });
export const updateNiveauCriticiteSuccess = (data)        => ({ type: UPDATE_NIVEAU_CRITICITE_SUCCESS, payload: data });
export const updateNiveauCriticiteFail    = (error)       => ({ type: UPDATE_NIVEAU_CRITICITE_FAIL, error });

export const deleteNiveauCriticiteRequest = (id)  => ({ type: DELETE_NIVEAU_CRITICITE_REQUEST, payload: { id } });
export const deleteNiveauCriticiteSuccess = (id)  => ({ type: DELETE_NIVEAU_CRITICITE_SUCCESS, payload: { id } });
export const deleteNiveauCriticiteFail    = (error) => ({ type: DELETE_NIVEAU_CRITICITE_FAIL, error });

export const setNiveauCriticiteLoading  = (loading) => ({ type: SET_NIVEAU_CRITICITE_LOADING, payload: loading });
export const clearNiveauCriticiteError  = ()        => ({ type: CLEAR_NIVEAU_CRITICITE_ERROR });
